'use client';

import { useNavigate } from "../../hooks/useNavigate";
import React from "react";
import { StyledButton } from "../Buttons/StyledButton";

const rightImg = "/assets/contact-us.svg";
function Head() {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/contact-us");
  };

  return (
    <div className="flex flex-col xl:flex-row items-start w-full max-w-[1024px] mx-auto">
      {/* Content Section */}

      {/* <div className="relative z-10 flex flex-col justify-center items-start text-left px-8 lg:pl-20 sm:w-full xl:w-[70%] mt-10 lg:mt-16 2xl:mt-20 mb-10"> */}
      <div className="relative z-10 flex flex-col justify-center items-start text-left px-8 w-full mt-10 lg:mt-12 2xl:mt-14 mb-10">
        <p className="text-color-2 text-[1.4rem] lg:text-[2.3rem] lg:leading-[3rem] flex flex-col items-center md:flex-row justify-between w-full">
          <span>Have any questions?</span>
          {/* <br /> */}
          {/* <span>Your Questions &amp; Needs Matter!</span> */}
          <span className="text-color-1">We respond quickly!</span>
        </p>
      </div>

      {/* Image Section */}
      {/* <div
        className="absolute xl:relative -right-32 w-full md:w-1/2 h-[200px] xl:h-[250px] bg-no-repeat rounded-3xl overflow-hidden blur-md md:blur-0 grayscale-[30%] opacity-80"
        style={{
          backgroundImage: `
            url('${rightImg}'), 
            radial-gradient(circle at bottom left, var(--primary-bg), transparent 40%),
            radial-gradient(circle at bottom right, var(--primary-bg), transparent 40%)`,
          backgroundSize: "contain, 100% 100%, 100% 100%, 100% 100%, 100% 100%",
          backgroundBlendMode: "overlay",
        }}
      ></div> */}
    </div>
  );
}

export default Head;
